// used this youTube video to help me with the template of this login (https://youtu.be/IwNVh5Rz7dI)

import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner } from "react-bootstrap";
import "../Login/Login.css";
import useAuth from "../../hooks/useAuth";
import img from "../images/face.png";

export default function Login() {
  const auth = useAuth();
  // We need to change the prompt to an imput per Vince's demo.
  async function loginNow() {
    try {
      const email = document.getElementById("theInput").value

      // const email = prompt("Enter your Email");
      await auth.login(email);
    } catch (err) {
      console.err(err);
    }
  }

  if (auth.loading || auth.loggingIn || auth.loggingOut) {
    return (
      <div className="text-center">
        <Spinner animation="border" variant="warning" role="status">
          <span className="sr-only"></span>
        </Spinner>
        <strong>Loading...</strong>
      </div>
    );
  }
  return (
    <div className="modal-dialog text-center">
      <div className="col-sm-9 main-section">
        <div className="modal-content">
          <div className="col-12 img-user">
            <img src={img} alt="user pic" />
            {auth.loggedIn ? (
              <div className="col-12 form-input">
                <form>
                  Logged In.
                  <br />
                  <button className="btn btn-warning button" onClick={() => auth.logout()}>
                    Logout
                  </button>
                </form>
              </div>
            ) : (
                <div className="col-12 form-input">
                  <form>
                    <input type="email" className="form-control" id="theInput" placeholder="Enter Email"></input>
                    <button className="btn btn-warning button" onClick={loginNow}>
                      Login Now
                  </button>
                  </form>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}
